import initialPageData from '@/mock.json'
import request from '@/utils/service.js'
import isArray from 'lodash/isArray';
import { CustomToast } from '@/utils/sspai-ui.js'

export default {
  login ({ commit }, data) {
    commit('setToken', data);
  },
  async updateUserInfo ({ commit }) {
    let userInfo = null
    try {
      const res1 = await request.get('/user/info/get')
      if (!res1.error) {
        userInfo = res1.data
      }
    } catch (error) {
      console.log(error)
    }
    commit('setUserInfo', userInfo)
  },
  async updatePageData ({ commit }) {
    let pageData = initialPageData
    if (process.env.NODE_ENV !== 'development') {
      pageData = window.__SSPAI_PAGE_JSON_DATA__
      commit('setPageData', pageData)
    }
  },
  async updateCategories ({ state, commit }) {
    const pageData = state.pageData
    try {
      if (pageData.categories && isArray(pageData.categories)) {
        const promisses = []
        pageData.categories.forEach(i => {
          promisses.push(request({
            url: '/series/article/search/page/get',
            params: {
              limit: 1,
              offset: 0,
              series_id: pageData.series,
              title_prefix: i.key,
              sort: 'desc',
              weight: 0
            }
          }).then(res => {
            i.count = res.total
            return res.total
          }))
        })
        await Promise.all(promisses)
        commit('setPageData', pageData)
      }
    } catch (error) {
      CustomToast({
        type: 'error',
        message: error.message
      })
    }
  },
  async updateSiteSetting ({ commit }) {
    try {
      const res = await request({
        url: '/setting/get'
      })
      if (res.error) throw new Error(res.msg)
      commit('setSetting', res.data)
    } catch (error) {
      CustomToast({
        type: 'error',
        message: error.message
      })
    }
  },
  async updateSeries ({ commit }, id) {
    try {
      const res = await request({
        url: '/series/info/get',
        params: {
          id
        }
      })
      if (res.error) throw new Error(res.msg)
      commit('setSeriesInfo', res.data)
    } catch (error) {
      CustomToast({
        type: 'error',
        message: error.message
      })
    }
  }
};
